class SearchBox {
    constructor() {
      this.events();
    }
  
    events() {
      window.addEventListener("load", () => this.changePlaceholder());
    }
  
    changePlaceholder() {
      let searchBox = document.querySelector('.wp-block-search__input');
      if (searchBox) {
          searchBox.placeholder = 'Buscar Productos…';
      }
    }
}
  
export default SearchBox;
